module.exports = __webpack_public_path__ + "img/privilege4.f675466f.png";